import React, { useRef, useState } from "react";
import { api, API } from "@/lib/api";
import { Upload, Link as LinkIcon, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

const resolveUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}${u}`;
};

export default function ImageUploader({ value = "", onChange, accept = "image/*", testid = "image-uploader", label = "Immagine" }) {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const upload = async (file) => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange?.(data.url);
      toast.success("File caricato");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload fallito");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testid} className="space-y-2">
      {label && <label className="overline text-muted-foreground block">{label}</label>}
      {value && (
        <div className="relative inline-block">
          <img src={resolveUrl(value)} alt="" className="w-28 h-28 object-cover rounded-sm border border-border" />
          <button
            type="button"
            data-testid={`${testid}-remove`}
            onClick={() => onChange?.("")}
            className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-foreground text-white flex items-center justify-center"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      <div className="flex gap-2 items-center">
        <input
          ref={fileRef}
          type="file"
          accept={accept}
          onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])}
          className="hidden"
          data-testid={`${testid}-file-input`}
        />
        <button
          type="button"
          data-testid={`${testid}-file-btn`}
          onClick={() => fileRef.current?.click()}
          disabled={busy}
          className="px-3 h-9 inline-flex items-center gap-1.5 rounded-sm border border-border text-xs hover:bg-accent transition-colors disabled:opacity-50"
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
          Carica file
        </button>
        <span className="text-xs text-muted-foreground">oppure URL</span>
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://…"
          data-testid={`${testid}-url-input`}
          className="flex-1 h-9 px-2 rounded-sm border border-border text-xs"
        />
        <button
          type="button"
          data-testid={`${testid}-url-btn`}
          onClick={() => { if (url) { onChange?.(url); setUrl(""); } }}
          className="px-3 h-9 inline-flex items-center gap-1.5 rounded-sm border border-border text-xs hover:bg-accent transition-colors"
        >
          <LinkIcon className="w-3.5 h-3.5" /> Usa URL
        </button>
      </div>
    </div>
  );
}

export { resolveUrl };
